export interface StatutCompteBeneficiaires {
    Code?: string,
    Libelle?: string
}

const VERIFICATION_EN_ATTENTE: string = "VEA";
const VALIDE: string = "VAL";
const ANNULE: string = "ANN";
const DESACTIVE: string = "DES";

export const StatutCompteBeneficiaires = {
    VERIFICATION_EN_ATTENTE,
    VALIDE,
    ANNULE,
    DESACTIVE
}